(function () {
  'use strict';

  var STORAGE_KEY = 'larrysaConsent';
  var LANG_KEY    = 'larrysaLang';

  var STRINGS = {
    pt: {
      body:   "Guardamos o essencial para o site funcionar e, se aceitares, usamos o Google Analytics (anónimo) para perceber o que melhorar. Sem publicidade, sem perfis.",
      bodyShort: "Usamos o Google Analytics (anónimo) para perceber o que melhorar. Sem publicidade.",
      accept: "Aceitar",
      deny:   "Agora não",
      more:   "Saber mais"
    },
    en: {
      body:   "We keep only the essentials for the site to work. If you accept, we use Google Analytics (anonymised) to understand what to improve. No ads, no profiling.",
      bodyShort: "We use Google Analytics (anonymised) to improve the site. No ads.",
      accept: "Accept",
      deny:   "Not now",
      more:   "Learn more"
    }
  };

  /* ---- helpers ---- */

  function injectCriticalUX() {
    if (document.getElementById('larrysa-critical-ux')) return;
    var s = document.createElement('style');
    s.id = 'larrysa-critical-ux';
    s.textContent = [
      'html,body{max-width:100%;overflow-x:hidden;}',
      '.nav__panel{display:none;}',
      '.nav__drop.open .nav__panel{display:block;}',
      '.nav__drop:not(.open) .nav__panel{visibility:hidden!important;opacity:0!important;pointer-events:none!important;}',
      '.hero,.vh,.cross,.menu-full,.menu-page,.planner,.festa-shell{max-width:100vw;overflow-x:clip;}',
      '.hero__img,.vh__bg,.cross__bg{max-width:100vw;overflow:hidden;}',
      '.menu-grid,.wrap{min-width:0;}',
      '@supports not (overflow:clip){.hero,.vh,.cross,.menu-full,.menu-page,.planner,.festa-shell{overflow-x:hidden;}}'
    ].join('');
    document.head.appendChild(s);
  }

  function normalizeNavState() {
    document.querySelectorAll('.nav__drop.open').forEach(function (drop) {
      drop.classList.remove('open');
      var btn = drop.querySelector('.nav__dt');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function parseRGB(str) {
    var m = /rgba?\(([^)]+)\)/.exec(str || '');
    if (!m) return null;
    var p = m[1].split(',').map(function (x) { return parseFloat(x); });
    return { r: p[0], g: p[1], b: p[2], a: p.length > 3 ? p[3] : 1 };
  }

  /* dark vs light banner — read the real page background luminance, so it
     adapts to the hub, the 404 and bakery night mode alike */
  function isDark() {
    try {
      var c = parseRGB(getComputedStyle(document.body).backgroundColor);
      if (!c || c.a === 0) c = parseRGB(getComputedStyle(document.documentElement).backgroundColor);
      if (!c || c.a === 0) return false;
      return (0.2126 * c.r + 0.7152 * c.g + 0.0722 * c.b) < 110;
    } catch (e) { return false; }
  }

  function currentLang() {
    return localStorage.getItem(LANG_KEY) === 'en' ? 'en' : 'pt';
  }

  function privacyHref() {
    /* Shopify route; survives theme routing changes. */
    return '/policies/privacy-policy';
  }

  /* ---- flight recorder ---- */

  function tryStartFlightRecorder() {
    if (window.FlightRecorder && window.LARRYSA_FR) {
      try { FlightRecorder.init(window.LARRYSA_FR); } catch (e) {}
    }
  }

  /* ---- banner rendering ---- */

  function buildBannerHTML(lang) {
    var s    = STRINGS[lang];
    var dark = isDark();
    var narrow  = !!(window.matchMedia && window.matchMedia('(max-width:480px)').matches);
    var bodyTxt = (narrow && s.bodyShort) ? s.bodyShort : s.body;

    var bg   = dark ? '#160C08' : '#FFFFFF';
    var fg   = dark ? '#F5F0EB' : '#160C08';
    var bdr  = dark ? '1px solid rgba(245,240,235,0.15)' : '1px solid rgba(22,12,8,0.12)';
    var link = dark ? '#F5F0EB' : '#160C08';

    var css = [
      '#cookie-consent{',
        'position:fixed;bottom:0;left:0;right:0;z-index:9999;',
        'background:' + bg + ';color:' + fg + ';',
        'border-top:' + bdr + ';',
        'padding:16px 20px;',
        'display:flex;flex-wrap:wrap;align-items:center;gap:12px;',
        'font-family:inherit;font-size:14px;line-height:1.5;',
        'box-shadow:0 -4px 24px rgba(0,0,0,.12);',
        'transition:transform .3s ease,opacity .3s ease;',
      '}',
      '#cookie-consent p{margin:0;flex:1 1 260px;}',
      '#cookie-consent .cc-actions{display:flex;flex-wrap:wrap;gap:8px;align-items:center;flex-shrink:0;}',
      '#cookie-consent button{',
        'border:none;cursor:pointer;font-size:14px;',
        'padding:8px 18px;border-radius:6px;',
        'transition:background .2s;',
      '}',
      '#cookie-consent .cc-accept{background:#E87843;color:#fff;}',
      '#cookie-consent .cc-accept:hover{background:#D55F2E;}',
      '#cookie-consent .cc-deny{background:transparent;color:' + fg + ';border:1px solid ' + fg + ';opacity:.75;}',
      '#cookie-consent .cc-deny:hover{opacity:1;}',
      '#cookie-consent .cc-more{font-size:13px;color:' + link + ';opacity:.7;text-decoration:underline;white-space:nowrap;}',
      '#cookie-consent .cc-more:hover{opacity:1;}',
      '@media(max-width:480px){',
        '#cookie-consent{left:8px;right:8px;bottom:max(6px,env(safe-area-inset-bottom));padding:6px 7px;gap:6px;font-size:11px;line-height:1.2;align-items:center;flex-wrap:nowrap;border:1px solid rgba(232,120,67,.22);border-radius:12px;box-shadow:0 12px 34px rgba(0,0,0,.22);}',
        '#cookie-consent p{flex:1 1 auto;min-width:0;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;}',
        '#cookie-consent .cc-actions{width:auto;display:grid;grid-template-columns:auto auto;gap:5px;align-items:center;flex:0 0 auto;}',
        '#cookie-consent .cc-accept,#cookie-consent .cc-deny{min-height:32px;padding:5px 8px;font-size:11px;border-radius:8px;white-space:nowrap;}',
        '#cookie-consent .cc-more{display:none;}',
      '}'
    ].join('');

    return { css: css, body: bodyTxt, accept: s.accept, deny: s.deny, more: s.more };
  }

  /* ---- banner lifecycle ---- */

  var banner    = null;
  var styleTag  = null;

  /* empurra o conteúdo para cima pela altura do banner, para não tapar
     botões (continuar do planeador, CTA dos rodapés). Expõe --cookie-h
     para os FAB poderem subir acima do banner. */
  function applyOffset() {
    if (!banner) return;
    var h = banner.offsetHeight || 0;
    document.documentElement.style.setProperty('--cookie-h', h + 'px');
    var ov = '';
    try { ov = getComputedStyle(document.body).overflowY; } catch (e) {}
    if (ov !== 'hidden') document.body.style.paddingBottom = h + 'px';
  }

  function clearOffset() {
    document.documentElement.style.setProperty('--cookie-h', '0px');
    document.body.style.paddingBottom = '';
  }

  function hideBanner() {
    if (!banner) return;
    clearOffset();
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if (prefersReduced) {
      banner.style.display = 'none';
    } else {
      banner.style.transform = 'translateY(100%)';
      banner.style.opacity   = '0';
      setTimeout(function () {
        if (banner && banner.parentNode) banner.parentNode.removeChild(banner);
        if (styleTag && styleTag.parentNode) styleTag.parentNode.removeChild(styleTag);
        banner   = null;
        styleTag = null;
      }, 320);
    }
  }

  function onAccept() {
    localStorage.setItem(STORAGE_KEY, 'granted');
    hideBanner();
    tryStartFlightRecorder();
    /* Consent Mode v2 — activa GA4 via GTM */
    if (window.gtag) gtag('consent', 'update', { analytics_storage: 'granted', ad_user_data: 'denied', ad_personalization: 'denied', ad_storage: 'denied' });
    if (window.dataLayer) window.dataLayer.push({ event: 'larrysa_consent_granted' });
  }

  function onDeny() {
    localStorage.setItem(STORAGE_KEY, 'denied');
    hideBanner();
  }

  function renderBanner() {
    var lang = currentLang();
    var d    = buildBannerHTML(lang);

    /* inject or update style tag */
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'cookie-consent-style';
      document.head.appendChild(styleTag);
    }
    styleTag.textContent = d.css;

    /* create banner element if needed */
    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'cookie-consent';
      banner.setAttribute('role', 'dialog');
      banner.setAttribute('aria-live', 'polite');
      banner.setAttribute('aria-label', lang === 'en' ? 'Cookie consent' : 'Consentimento de cookies');
      document.body.appendChild(banner);
    }

    /* build DOM nodes — no innerHTML, no untrusted content */
    var p = document.createElement('p');
    p.textContent = d.body;

    var btnAccept = document.createElement('button');
    btnAccept.className = 'cc-accept';
    btnAccept.textContent = d.accept;
    btnAccept.addEventListener('click', onAccept);

    var btnDeny = document.createElement('button');
    btnDeny.className = 'cc-deny';
    btnDeny.textContent = d.deny;
    btnDeny.addEventListener('click', onDeny);

    var linkMore = document.createElement('a');
    linkMore.className = 'cc-more';
    linkMore.href = privacyHref();
    linkMore.textContent = d.more;

    var actions = document.createElement('div');
    actions.className = 'cc-actions';
    actions.appendChild(btnAccept);
    actions.appendChild(btnDeny);
    actions.appendChild(linkMore);

    /* clear any previous render and repopulate */
    while (banner.firstChild) banner.removeChild(banner.firstChild);
    banner.appendChild(p);
    banner.appendChild(actions);

    /* mede e empurra o conteúdo depois do layout */
    if (window.requestAnimationFrame) requestAnimationFrame(applyOffset);
    else applyOffset();
  }

  /* ---- init ---- */

  /* BANNER CUSTOM DESACTIVADO (10 Jul 2026) — duplicava o consentimento
     nativo da Shopify (Customer Privacy API), chegando a tapar preço/nome
     de produto em mobile. injectCriticalUX/normalizeNavState continuam
     activos (fixes de overflow e de estado da nav, não relacionados com
     cookies). Ver 00-BENCHMARK/RUNS/2026-07-10-1608/report.md. */
  var COOKIE_BANNER_ENABLED = false;

  function init() {
    injectCriticalUX();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', normalizeNavState, { once: true });
    } else {
      normalizeNavState();
    }

    if (!COOKIE_BANNER_ENABLED) return;

    var stored = localStorage.getItem(STORAGE_KEY);

    if (stored === 'granted') {
      /* already consented — start FR and activate GA4 immediately */
      tryStartFlightRecorder();
      if (window.gtag) gtag('consent', 'update', { analytics_storage: 'granted', ad_user_data: 'denied', ad_personalization: 'denied', ad_storage: 'denied' });
      if (window.dataLayer) window.dataLayer.push({ event: 'larrysa_consent_granted' });
      return;
    }

    if (stored === 'denied') {
      /* user said no — honour it, don't show banner again */
      return;
    }

    /* no decision yet — show banner when DOM is ready */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', renderBanner);
    } else {
      renderBanner();
    }

    /* re-render banner text if language switches while banner is visible */
    window.addEventListener('larrysa:lang', function () {
      if (banner) renderBanner();
    });

    /* re-mede o empurrão se o banner muda de altura; re-renderiza ao cruzar
       o breakpoint mobile, para trocar entre texto curto e longo */
    var lastNarrow = !!(window.matchMedia && window.matchMedia('(max-width:480px)').matches);
    window.addEventListener('resize', function () {
      if (!banner) return;
      var nowNarrow = !!(window.matchMedia && window.matchMedia('(max-width:480px)').matches);
      if (nowNarrow !== lastNarrow) { lastNarrow = nowNarrow; renderBanner(); }
      else applyOffset();
    });
  }

  init();

}());
